import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const msgBox = css({ padding: '15px 0px' });
export const success = css({ color: colorsPalette.teal });
export const error = css({ color: colorsPalette.red });
export const phoneNumberFieldCssProps = {
  container: css({
    minHeight: '56px',
    padding: '12px 16px',
    borderRadius: '4px',
  }),
};
